import { ui } from "@/components/ui";
import { useEntryValuesStore } from "@/features/inputs/hooks/useEntryValuesStore";
import { Route as EditObservationRoute } from "@/routes/_app/diaries/$diaryId/edit/observation/$observationId";
import { Route as PageRoute } from "@/routes/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/page/$pageIndex";
import { Link } from "@tanstack/react-router";
import { ArrowRight, Pencil } from "lucide-react";
import { v4 as uuidv4 } from "uuid";
import { toKebabCase } from "../../../services/capitaliseSentence";

interface ObservationEntryCardButtonsProps {
	diaryId: string;
	observationId: string | null;
	observationName: string;
	isNextEntryLocked: boolean;
	showNextEntryButton?: boolean;
	showEditButton?: boolean;
	nextEntryLabel?: string;
}

const ObservationEntryCardButtons = ({
	diaryId,
	observationId,
	observationName,
	isNextEntryLocked,
	showNextEntryButton = true,
	showEditButton = false,
	nextEntryLabel = "Next",
}: ObservationEntryCardButtonsProps) => {
	const { resetEntryValues } = useEntryValuesStore();
	const newEntryId = uuidv4();

	return (
		<>
			{showNextEntryButton && observationId && (
				<ui.Button
					data-testid={`observation-button-${toKebabCase(observationName)}`}
					tabIndex={-1}
					disabled={isNextEntryLocked}
					size="lg"
					asChild
					variant="default"
				>
					<Link
						onClick={resetEntryValues}
						to={PageRoute.to}
						params={{
							diaryId: diaryId,
							entryId: newEntryId,
							observationId: observationId,
							pageIndex: String(1),
						}}
					>
						{nextEntryLabel}
						<ArrowRight className="w-4 h-4 transition-all group-hover:translate-x-1 duration-300 ease-in-out" />
					</Link>
				</ui.Button>
			)}

			{showEditButton && observationId && (
				<ui.Button variant="secondary" size="lg" asChild>
					<Link
						to={EditObservationRoute.to}
						params={{
							diaryId: diaryId,
							observationId: observationId,
						}}
						className="flex flex-row justify-center items-center gap-2"
					>
						<Pencil />
						Edit
					</Link>
				</ui.Button>
			)}
		</>
	);
};

export default ObservationEntryCardButtons;
